import { getBundlesForRelease } from "./featureRegistry";

/**
 * Assembles Ashley Release Brief copy from release metadata and bundle segments.
 */
export function resolveBriefScript(releaseMeta, releaseId) {
  if (!releaseMeta) {
    return {
      greeting: "Welcome back.",
      paragraphs: [],
      closingPrompt: "When you're ready, press Continue.",
    };
  }

  const bundles = getBundlesForRelease(releaseId)
    .filter((bundle) => bundle.ashleyBriefSegment)
    .sort((a, b) => a.displayOrder - b.displayOrder);

  const bodyFromMeta = Array.isArray(releaseMeta.ashleyBrief?.body)
    ? releaseMeta.ashleyBrief.body
    : [];

  const bundleParagraphs = bundles.map((bundle) => bundle.ashleyBriefSegment);
  const paragraphs =
    bodyFromMeta.length > 0 ? bodyFromMeta : bundleParagraphs;

  return {
    greeting: releaseMeta.ashleyBrief?.greeting || "Welcome back.",
    title: releaseMeta.title,
    theme: releaseMeta.theme,
    description: releaseMeta.description,
    paragraphs,
    closingPrompt:
      releaseMeta.ashleyBrief?.closingPrompt ||
      "Would you like me to show you around?",
  };
}
